// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file api/agent/svc_agent.proto (package com.diagnocat.agent.v1, syntax proto3)
/* eslint-disable */

import { proto3 } from "@bufbuild/protobuf";

/**
 * CreateAgentThreadReq starts an empty owner-private conversation before
 * the first message, so attachments can be uploaded.
 *
 * @generated from message com.diagnocat.agent.v1.CreateAgentThreadReq
 */
export const CreateAgentThreadReq = proto3.makeMessageType(
  "com.diagnocat.agent.v1.CreateAgentThreadReq",
  () => [
    { no: 1, name: "Context", kind: "message", T: RunContext },
    { no: 2, name: "SubjectType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "SubjectID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.agent.v1.CreateAgentThreadResp
 */
export const CreateAgentThreadResp = proto3.makeMessageType(
  "com.diagnocat.agent.v1.CreateAgentThreadResp",
  () => [
    { no: 1, name: "Thread", kind: "message", T: AgentThread },
  ],
);

/**
 * @generated from message com.diagnocat.agent.v1.RunAgentReq
 */
export const RunAgentReq = proto3.makeMessageType(
  "com.diagnocat.agent.v1.RunAgentReq",
  () => [
    { no: 1, name: "Context", kind: "message", T: RunContext },
    { no: 2, name: "Message", kind: "message", T: UserMessage },
    { no: 4, name: "ThreadID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "SubjectType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "SubjectID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.agent.v1.UserMessage
 */
export const UserMessage = proto3.makeMessageType(
  "com.diagnocat.agent.v1.UserMessage",
  () => [
    { no: 1, name: "Blocks", kind: "message", T: UserMessageBlock, repeated: true },
    { no: 2, name: "PageContext", kind: "message", T: PageContext },
    { no: 3, name: "Approval", kind: "message", T: UserApproval },
  ],
);

/**
 * @generated from message com.diagnocat.agent.v1.UserApproval
 */
export const UserApproval = proto3.makeMessageType(
  "com.diagnocat.agent.v1.UserApproval",
  () => [
    { no: 1, name: "ProposalID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Decision", kind: "enum", T: proto3.getEnumType(UserApproval_ApprovalDecision) },
  ],
);

/**
 * @generated from enum com.diagnocat.agent.v1.UserApproval.ApprovalDecision
 */
export const UserApproval_ApprovalDecision = proto3.makeEnum(
  "com.diagnocat.agent.v1.UserApproval.ApprovalDecision",
  [
    {no: 0, name: "DecisionUnspecified"},
    {no: 1, name: "DecisionApprove"},
    {no: 2, name: "DecisionDisapprove"},
    {no: 3, name: "DecisionFeedback"},
  ],
);

/**
 * @generated from message com.diagnocat.agent.v1.PageContext
 */
export const PageContext = proto3.makeMessageType(
  "com.diagnocat.agent.v1.PageContext",
  () => [
    { no: 1, name: "Page", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Resources", kind: "message", T: PageResource, repeated: true },
    { no: 3, name: "DOM", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.agent.v1.PageResource
 */
export const PageResource = proto3.makeMessageType(
  "com.diagnocat.agent.v1.PageResource",
  () => [
    { no: 1, name: "Type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.agent.v1.UserMessageBlock
 */
export const UserMessageBlock = proto3.makeMessageType(
  "com.diagnocat.agent.v1.UserMessageBlock",
  () => [
    { no: 1, name: "Text", kind: "message", T: UserTextBlock, oneof: "Content" },
    { no: 2, name: "File", kind: "message", T: UserFileBlock, oneof: "Content" },
  ],
);

/**
 * @generated from message com.diagnocat.agent.v1.UserTextBlock
 */
export const UserTextBlock = proto3.makeMessageType(
  "com.diagnocat.agent.v1.UserTextBlock",
  () => [
    { no: 1, name: "Text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * UserFileBlock references a file already persisted as a core ChatUpload
 * asset. Only the asset id and presentation metadata travel with the message.
 *
 * @generated from message com.diagnocat.agent.v1.UserFileBlock
 */
export const UserFileBlock = proto3.makeMessageType(
  "com.diagnocat.agent.v1.UserFileBlock",
  () => [
    { no: 1, name: "AssetID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "MIME", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Size", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "SHA256", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.agent.v1.RunAgentResp
 */
export const RunAgentResp = proto3.makeMessageType(
  "com.diagnocat.agent.v1.RunAgentResp",
  () => [
    { no: 1, name: "Started", kind: "message", T: RunStarted, oneof: "Event" },
    { no: 2, name: "ToolCallStarted", kind: "message", T: ToolCallStarted, oneof: "Event" },
    { no: 3, name: "ToolCallCompleted", kind: "message", T: ToolCallCompleted, oneof: "Event" },
    { no: 4, name: "MessageDelta", kind: "message", T: MessageDelta, oneof: "Event" },
    { no: 5, name: "MessageCompleted", kind: "message", T: MessageCompleted, oneof: "Event" },
    { no: 6, name: "Completed", kind: "message", T: RunCompleted, oneof: "Event" },
    { no: 7, name: "Failed", kind: "message", T: AgentError, oneof: "Event" },
    { no: 8, name: "Activity", kind: "message", T: AgentActivity, oneof: "Event" },
    { no: 9, name: "Artifact", kind: "message", T: AgentArtifact, oneof: "Event" },
  ],
);

/**
 * @generated from message com.diagnocat.agent.v1.ListAgentThreadsReq
 */
export const ListAgentThreadsReq = proto3.makeMessageType(
  "com.diagnocat.agent.v1.ListAgentThreadsReq",
  () => [
    { no: 1, name: "Context", kind: "message", T: RunContext },
    { no: 2, name: "Limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "SubjectType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "SubjectID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.agent.v1.ListAgentThreadsResp
 */
export const ListAgentThreadsResp = proto3.makeMessageType(
  "com.diagnocat.agent.v1.ListAgentThreadsResp",
  () => [
    { no: 1, name: "Threads", kind: "message", T: AgentThread, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.agent.v1.GetAgentThreadReq
 */
export const GetAgentThreadReq = proto3.makeMessageType(
  "com.diagnocat.agent.v1.GetAgentThreadReq",
  () => [
    { no: 1, name: "ThreadID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "MessageLimit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message com.diagnocat.agent.v1.GetAgentThreadResp
 */
export const GetAgentThreadResp = proto3.makeMessageType(
  "com.diagnocat.agent.v1.GetAgentThreadResp",
  () => [
    { no: 1, name: "Thread", kind: "message", T: AgentThread },
    { no: 2, name: "Messages", kind: "message", T: ConversationMessage, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.agent.v1.AgentThread
 */
export const AgentThread = proto3.makeMessageType(
  "com.diagnocat.agent.v1.AgentThread",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "CreatedAt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "UpdatedAt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "Title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "LastMessagePreview", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "CreatorID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "ArchivedBy", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "ArchivedAt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "UnarchivedBy", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "UnarchivedAt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "PatientID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "SubjectType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "SubjectID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.agent.v1.ArchiveAgentThreadReq
 */
export const ArchiveAgentThreadReq = proto3.makeMessageType(
  "com.diagnocat.agent.v1.ArchiveAgentThreadReq",
  () => [
    { no: 1, name: "ThreadID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Archive", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message com.diagnocat.agent.v1.ArchiveAgentThreadResp
 */
export const ArchiveAgentThreadResp = proto3.makeMessageType(
  "com.diagnocat.agent.v1.ArchiveAgentThreadResp",
  () => [
    { no: 1, name: "Thread", kind: "message", T: AgentThread },
  ],
);

/**
 * @generated from message com.diagnocat.agent.v1.RunContext
 */
export const RunContext = proto3.makeMessageType(
  "com.diagnocat.agent.v1.RunContext",
  () => [
    { no: 1, name: "PatientID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.agent.v1.ConversationMessage
 */
export const ConversationMessage = proto3.makeMessageType(
  "com.diagnocat.agent.v1.ConversationMessage",
  () => [
    { no: 1, name: "Role", kind: "enum", T: proto3.getEnumType(ConversationMessage_MessageRole) },
    { no: 2, name: "Content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Activity", kind: "message", T: AgentActivity },
    { no: 4, name: "Artifact", kind: "message", T: AgentArtifact },
    { no: 5, name: "AuthorID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "Attachments", kind: "message", T: UserFileBlock, repeated: true },
    { no: 7, name: "CreatedAt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "Approval", kind: "message", T: UserApproval },
    { no: 9, name: "Context", kind: "message", T: RunContext },
    { no: 10, name: "PageContext", kind: "message", T: PageContext },
    { no: 11, name: "ContextLabel", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from enum com.diagnocat.agent.v1.ConversationMessage.MessageRole
 */
export const ConversationMessage_MessageRole = proto3.makeEnum(
  "com.diagnocat.agent.v1.ConversationMessage.MessageRole",
  [
    {no: 0, name: "RoleUnspecified"},
    {no: 1, name: "RoleUser"},
    {no: 2, name: "RoleAssistant"},
    {no: 3, name: "RoleSystem"},
  ],
);

/**
 * AgentActivity is a semantic description of work visible to the user. Tool
 * names, command lines, and transport payloads must not be exposed here.
 *
 * @generated from message com.diagnocat.agent.v1.AgentActivity
 */
export const AgentActivity = proto3.makeMessageType(
  "com.diagnocat.agent.v1.AgentActivity",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Kind", kind: "enum", T: proto3.getEnumType(AgentActivity_ActivityKind) },
    { no: 3, name: "State", kind: "enum", T: proto3.getEnumType(AgentActivity_ActivityState) },
    { no: 4, name: "Data", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 5, name: "ErrorCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from enum com.diagnocat.agent.v1.AgentActivity.ActivityKind
 */
export const AgentActivity_ActivityKind = proto3.makeEnum(
  "com.diagnocat.agent.v1.AgentActivity.ActivityKind",
  [
    {no: 0, name: "KindUnspecified"},
    {no: 1, name: "KindWorking"},
    {no: 2, name: "KindSearchRecords"},
    {no: 3, name: "KindReadReport"},
    {no: 4, name: "KindReadConsultation"},
    {no: 5, name: "KindCompareReports"},
    {no: 6, name: "KindInspectImages"},
    {no: 7, name: "KindListDocuments"},
    {no: 8, name: "KindReadDocument"},
    {no: 9, name: "KindCreateDocument"},
    {no: 10, name: "KindUpdateDocument"},
    {no: 11, name: "KindAnalyzePatientData"},
  ],
);

/**
 * @generated from enum com.diagnocat.agent.v1.AgentActivity.ActivityState
 */
export const AgentActivity_ActivityState = proto3.makeEnum(
  "com.diagnocat.agent.v1.AgentActivity.ActivityState",
  [
    {no: 0, name: "StateUnspecified"},
    {no: 1, name: "StateRunning"},
    {no: 2, name: "StateCompleted"},
    {no: 3, name: "StateFailed"},
  ],
);

/**
 * @generated from message com.diagnocat.agent.v1.AgentArtifact
 */
export const AgentArtifact = proto3.makeMessageType(
  "com.diagnocat.agent.v1.AgentArtifact",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Kind", kind: "enum", T: proto3.getEnumType(AgentArtifact_ArtifactKind) },
    { no: 3, name: "Action", kind: "enum", T: proto3.getEnumType(AgentArtifact_ArtifactAction) },
    { no: 4, name: "ResourceID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "Title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "Data", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ],
);

/**
 * @generated from enum com.diagnocat.agent.v1.AgentArtifact.ArtifactKind
 */
export const AgentArtifact_ArtifactKind = proto3.makeEnum(
  "com.diagnocat.agent.v1.AgentArtifact.ArtifactKind",
  [
    {no: 0, name: "KindUnspecified"},
    {no: 1, name: "KindPatientDocument"},
    {no: 2, name: "KindApprovalRequest"},
    {no: 3, name: "KindDocumentTemplate"},
    {no: 4, name: "KindEncounterSchema"},
  ],
);

/**
 * @generated from enum com.diagnocat.agent.v1.AgentArtifact.ArtifactAction
 */
export const AgentArtifact_ArtifactAction = proto3.makeEnum(
  "com.diagnocat.agent.v1.AgentArtifact.ArtifactAction",
  [
    {no: 0, name: "ActionUnspecified"},
    {no: 1, name: "ActionCreated"},
    {no: 2, name: "ActionUpdated"},
    {no: 3, name: "ActionProposed"},
  ],
);

/**
 * @generated from message com.diagnocat.agent.v1.RunStarted
 */
export const RunStarted = proto3.makeMessageType(
  "com.diagnocat.agent.v1.RunStarted",
  () => [
    { no: 1, name: "RunID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "PlannedToolIDs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "ThreadID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.agent.v1.ToolCallStarted
 */
export const ToolCallStarted = proto3.makeMessageType(
  "com.diagnocat.agent.v1.ToolCallStarted",
  () => [
    { no: 1, name: "ToolCallID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ToolID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "InputJSON", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.agent.v1.ToolCallCompleted
 */
export const ToolCallCompleted = proto3.makeMessageType(
  "com.diagnocat.agent.v1.ToolCallCompleted",
  () => [
    { no: 1, name: "ToolCallID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ToolID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "OutputJSON", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.agent.v1.MessageDelta
 */
export const MessageDelta = proto3.makeMessageType(
  "com.diagnocat.agent.v1.MessageDelta",
  () => [
    { no: 1, name: "Content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.agent.v1.MessageCompleted
 */
export const MessageCompleted = proto3.makeMessageType(
  "com.diagnocat.agent.v1.MessageCompleted",
  () => [
    { no: 1, name: "Content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.agent.v1.RunCompleted
 */
export const RunCompleted = proto3.makeMessageType(
  "com.diagnocat.agent.v1.RunCompleted",
  () => [
    { no: 1, name: "RunID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "UsedToolIDs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "ThreadID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.agent.v1.AgentError
 */
export const AgentError = proto3.makeMessageType(
  "com.diagnocat.agent.v1.AgentError",
  () => [
    { no: 1, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

